import ModuleHelper = require('./ModuleHelper');
/**
 * Drag helper for new sections (from section selector)
 */
export default class BlankSectionHelper extends ModuleHelper {
    protected restrictedTooltipOptions = {
        anchorOffset: -12
    };
    create(sourceElem: JQuery) {
        return sourceElem
            .clone()
            .addClass("drag-container")
            .css({
                width: sourceElem.width(),
                height: sourceElem.height()
            });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/BlankSectionHelper.ts
 **/